
import React, { useEffect, useState } from 'react'
import { QeWrapper } from './style';
import styled from 'styled-components';
import IconClose from '../../assets/images/IconClose';

function Iframe({close}) {
    const Wrapper = styled.div`
  /* display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  left: 0;
  top: 0;
  width: 100vw;

  background-color: #333;
  overflow: hidden; */
  .qrWeapper {
    z-index: 1111;

    & > div {
  max-width: 1100px;
  min-height: 90vh;
  position: relative;
  .header{
    position: absolute;
    right: 0;
    background-color: transparent;
    padding: 9px 22px 4px;
  }
  .maiBox{
    max-width: 100%;
    width: 100%;
    height: 100%;
   padding: 0!important;
  }
  iframe{
    width: 100%;
    min-height: 90vh;
    border: none;
  }
  }
  }

 
`;

// useEffect(() => {
//     const iframe = document.getElementById("paymentIframe");
  
//     iframe.onload = () => {
//       try {
//         iframe.contentWindow.eval(`
//           Object.defineProperty(window, 'top', {
//             get: function() { return window.self; }
//           });
//         `);
//       } catch (error) {
//         console.log("Cannot override window.top due to cross-origin restrictions.");
//       }
//     };
//   }, []);



// useEffect(() => {
//   const iframe = document.getElementById("paymentIframe");

//   const detectRedirect = () => {
//     try {
 
//       console.log("Current Iframe URL:", iframe.contentWindow.location.href);
   
//     } catch (error) {
//       console.log("Redirect detected! Reloading iframe...",iframe.src);
//     }
//   };

//   const interval = setInterval(detectRedirect, 1000);

//   return () => clearInterval(interval);
// }, []);
  

const [loading, setLoading] = useState(true); // State to track loading

useEffect(() => {
//   const iframe = document.getElementById("paymentIframe");

//   if (iframe) {
//     iframe.onload = () => {
//       console.log("Iframe Loaded!");
//       setLoading(false); 
//     };
//   }
}, []);


  return (
    <div>
        <Wrapper >

          <QeWrapper className="qrWeapper flex">
				<div className="">
					<div className="flex header">
						<div className="close" onClick={close}>
							<IconClose />
						</div>
					</div>

					<div className="maiBox">
                    
						<iframe   name='paymentIframe' 
                        id="paymentIframe"  
                        
                         // sandbox="allow-forms allow-scripts allow-same-origin allow-popups"
 ></iframe>
					</div>
					<div className="bottom"></div>
				</div>
			</QeWrapper>

        </Wrapper>
    </div>
  )
}

export default Iframe;

